import { Base } from "ui/Scripts/source/framework/base";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { IUserGroupListItems, UserGroupListItems } from "ui/Scripts/source/models/userGroup/userGroupListItems";

export interface IUserGroupPage {
    companies: ICompanyMenuItem[];
    authorizationLevels: INumberTitle[];
    list: IUserGroupListItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
}

export class UserGroupPage implements IUserGroupPage {
    companies: CompanyMenuItem[];
    authorizationLevels: NumberTitle[];
    list: UserGroupListItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];

    constructor();
    constructor(obj: IUserGroupPage);
    constructor(obj?: any) {
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.authorizationLevels = Base.getTypedArray(obj ? obj.authorizationLevels : null, NumberTitle);
        this.list = new UserGroupListItems(obj && obj.list || null);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
    }
}